import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'

class Email {
  // get all brokers a user belongs to
  async sendEmail({
    html,
    emailTo,
    subject,
    attachments,
  }: {
    html: string
    emailTo: string
    subject: string
    attachments?: File[]
  }): Promise<any | (AxiosError | Error)> {
    const url = APIRoutes.email.sendEmail

    const formData = new FormData()
    formData.append('subject', subject)
    formData.append('body', html)
    formData.append('toEmail', emailTo)
    if (attachments) {
      attachments.forEach(file => {
        formData.append(`attachments`, file)
      })
    }

    return ApiProvider.postRequest(url, formData, true) as Promise<
      any | (AxiosError | Error)
    >
  }

  async sendProposalEmail({
    broker,
    policyNo,
    eventNo,
    product,
    email,
    username,
    CCEmail,
    BCCEmail,
    EmailBody,
  }: {
    broker: string
    policyNo: string
    eventNo: string
    product: string
    email: string
    username: string
    CCEmail?: string
    BCCEmail?: string
    EmailBody?: string
  }): Promise<any | (AxiosError | Error)> {
    const url = APIRoutes.email.sendProposalEmail
    const formData = new FormData()
    formData.append('broker', broker)
    formData.append('policyNo', policyNo)
    formData.append('eventNo', eventNo)
    formData.append('product', product)
    formData.append('email', email)
    formData.append('CCEmail', CCEmail || '')
    formData.append('BCCEmail', BCCEmail || '')
    formData.append('EmailBody', EmailBody || '')
    formData.append('username', username)

    return ApiProvider.postRequest(url, formData, true) as Promise<
      any | (AxiosError | Error)
    >
  }
}

export const emailService = new Email()
